import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { API_BASE_URL } from "../../../config";
import {
  FaCheckCircle,
  FaClock,
  FaCalendarAlt,
  FaDollarSign,
  FaDoorOpen,
  FaCar,
  FaDog,
  FaSwimmingPool,
  FaListAlt,
} from "react-icons/fa";


/* ----------------- small helpers ----------------- */

const Section = ({ title, color, children }) => (
  <section style={{ marginTop: "25px" }}>
    <h2 style={{ borderBottom: `2px solid ${color}`, paddingBottom: "5px" }}>
      {title}
    </h2>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "15px",
        marginTop: "10px",
      }}
    >
      {children}
    </div>
  </section>
);

const Info = ({ icon, label, value, isText = false }) => {
  let displayValue = value;

  if (!isText) {
    if (
      value === true ||
      value === 1 ||
      value === "1" ||
      value === "true" ||
      value === "yes" ||
      value === "Yes"
    ) {
      displayValue = "Yes";
    } else if (
      value === false ||
      value === 0 ||
      value === "0" ||
      value === "false" ||
      value === "no" ||
      value === "No"
    ) {
      displayValue = "No";
    }
  }

  if (displayValue === null || displayValue === undefined || displayValue === "") {
    displayValue = "—";
  }

  return (
    <div
      style={{
        background: "#f8f9fa",
        borderRadius: "12px",
        padding: "14px 16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        display: "flex",
        gap: "12px",
      }}
    >
      <div style={{ fontSize: "1.2rem", color: "#2e7d32" }}>
        {icon}
      </div>
      <div>
        <div style={{ fontWeight: 700 }}>{label}</div>
        <div style={{ color: "#555" }}>{displayValue}</div>
      </div>
    </div>
  );
};

/* ✅ Pool care tasks (you can change these later) */
const TASK_DEFINITIONS = [
  { key: "waterTesting", label: "water testing" },
  { key: "chemicalBalancing", label: "chemical balancing" },
  { key: "skimming", label: "skimming" },
  { key: "vacuuming", label: "vacuuming" },
  { key: "brushing", label: "brushing" },
  { key: "filterCleaning", label: "filter cleaning" },
  { key: "saltCellCleaning", label: "salt cell cleaning" },
  { key: "chemicalSupplyIncluded", label: "chemicals included" },
];

/* ----------------- main component ----------------- */

function PoolCareDetails() {
  const { listingId } = useParams();
  const [listing, setListing] = useState(null);



  useEffect(() => {
    async function load() {
      try {
        // ✅ poolcare endpoints (support either by-listing-id or numeric id)
        const isPublicId =
          String(listingId).toUpperCase().startsWith("POOL-") ||
          String(listingId).toUpperCase().startsWith("PCL-") ||
          String(listingId).toUpperCase().startsWith("PC-") ||
          String(listingId).includes("-");

        const url = isPublicId
          ? `${API_BASE_URL}/api/poolcare/listings/by-listing-id/${listingId}`
          : `${API_BASE_URL}/api/poolcare/listings/${listingId}`;

        const res = await fetch(url);
        const data = await res.json();

        setListing(data);
      } catch (err) {
        console.error("Failed to load pool care listing:", err);
      }
    }

    load();
}, [listingId]);

  if (!listing) return <p>Loading.</p>;

  const getGoogleMapsLink = (suburb, postcode, state) => {
  const location = `${suburb || ""} ${postcode || ""} ${state || ""} Australia`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
};

  const formattedDate =
  listing.createdAt || listing.created_at
    ? new Date(
        listing.createdAt || listing.created_at
      ).toLocaleDateString("en-AU")
    : "—";


 const services =
  listing.services && typeof listing.services === "object"
    ? listing.services
    : listing;

  // =========================
  // BUY POOL CARE LISTING
  // =========================
 const handleBuyNow = async () => {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("You must be logged in to buy this listing.");
      return;
    }

    const res = await fetch(`${API_BASE_URL}/api/poolcare/payment/buy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        listingId: listing.listingId,
      }),
    });

    const data = await res.json();

    if (!res.ok || !data.url) {
      alert(data.error || "Failed to start checkout.");
      return;
    }

    window.location.href = data.url;
  } catch (err) {
    console.error("Buy error:", err);
    alert("Failed to buy listing.");
  }
};


  return (
    <div style={container}>
      {/* HERO IMAGE */}
      <img src="/images/poolcare.jpg" alt="Pool Care" style={hero} />

      <div style={{ padding: "25px" }}>
        <h2>Pool Care Client – {listing.listingId}</h2>

      <a
  href={getGoogleMapsLink(
    listing.suburb,
    listing.postcode,
    listing.state
  )}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: "#555",
    marginTop: 4,
    display: "inline-block",
    textDecoration: "none",
  }}
>
  <span
    style={{
      display: "inline-block",
      transition: "transform 0.2s ease",
      color: "#2e7d32",
      cursor: "pointer",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
    }}
  >
    📍
  </span>{" "}
  {listing.suburb}, {listing.state} {listing.postcode}
</a>

        {/* STATUS */}
        {listing.listing_status === "locked" && (
          <div
            style={{
              marginTop: 16,
              padding: 12,
              background: "#fff3e0",
              border: "1px solid #ff9800",
              borderRadius: 8,
              textAlign: "center",
            }}
          >
            <h3 style={{ color: "#e65100", marginBottom: 8 }}>Buy in Progress</h3>
            <p style={{ margin: 0 }}>
              Another buyer is currently completing this purchase. Please check
              back shortly.
            </p>
          </div>
        )}

        {listing.listing_status === "sold" && (
          <p style={{ color: "red", marginTop: 10, fontWeight: "bold" }}>
            This listing has been sold.
          </p>
        )}

        {/* POOL DETAILS */}
    <Section title="🏊 Pool Details" color="#0288d1">
  <Info icon={<FaSwimmingPool />} label="Pool Type" value={listing.poolType || "—"} isText />
  <Info icon={<FaSwimmingPool />} label="Pool Size" value={listing.poolSize || "—"} isText />
  <Info icon={<FaSwimmingPool />} label="Surface" value={listing.poolSurface || "—"} isText />
  <Info icon={<FaSwimmingPool />} label="Spa Included" value={listing.hasSpa} />
</Section>

        {/* SERVICE SCHEDULE */}
<Section title="📅 Service Schedule" color="#43a047">
  <Info icon={<FaCalendarAlt />} label="Frequency" value={listing.frequency || "—"} isText />
  <Info icon={<FaCalendarAlt />} label="Preferred Day" value={listing.serviceDay || "—"} isText />
  <Info icon={<FaClock />} label="Preferred Time" value={listing.serviceTime || "—"} isText />
</Section>

{/* INCLUDED SERVICES */}
<Section title="📅 Service Schedule" color="#43a047">
  <Info icon={<FaCalendarAlt />} label="Frequency" value={listing.frequency || "—"} isText />
  <Info icon={<FaCalendarAlt />} label="Preferred Day" value={listing.serviceDay || "—"} isText />
  <Info icon={<FaClock />} label="Preferred Time" value={listing.serviceTime || "—"} isText />
</Section>

        {/* ACCESS */}
    <Section title="🧪 Included Services" color="#8e24aa">
  <div style={{ gridColumn: "1 / -1" }}>
    <div style={tasksGrid}>
      {TASK_DEFINITIONS
        .filter(
          (t) =>
            services[t.key] === true ||
            services[t.key] === 1 ||
            services[t.key] === "1" ||
            services[t.key] === "true"
        )
        .map((t) => (
          <p key={t.key} style={{ margin: "4px 0" }}>
            ✔ {t.label}
          </p>
        ))}
    </div>
  </div>
</Section>

                {/* CLIENT HISTORY */}
 <Section title="🕒 Client History" color="#8e24aa">
  <Info
    icon={<FaCalendarAlt />}
    label="Client History"
    value={
      listing.newClient
        ? "New client (under 6 months)"
        : listing.longTermClient
        ? "Long-term client (12+ months)"
        : "Established client (6–12 months)"
    }
    isText
  />
</Section>


       {/* FINANCIALS */}
<Section title="💰 Financials" color="#fb8c00">
  <Info
    icon={<FaDollarSign />}
    label="Service Fee"
    value={
      listing.serviceFee !== null && listing.serviceFee !== undefined
        ? `$${Number(listing.serviceFee).toFixed(2)}`
        : "—"
    }
    isText
  />
  <Info
    icon={<FaListAlt />}
    label="Sale Price"
    value={
      listing.salePrice !== null && listing.salePrice !== undefined
        ? `$${Number(listing.salePrice).toFixed(2)}`
        : "—"
    }
    isText
  />
</Section>

{/* Listing Verification */}
<div style={{ marginTop: "20px" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <FaCheckCircle color="#2e7d32" />
    <strong>Posted On: {formattedDate}</strong>
  </div>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "6px",
      color: "#2e7d32",
    }}
  >
    <FaCheckCircle />
    Seller confirmed this listing is genuine.
  </div>
</div>


{/* BUY BUTTON */}
<button
  onClick={() => {
   if (!["active", "live"].includes(listing.listing_status)) {
      alert("Listing is currently being purchased by another user.");
      return;
    }
    handleBuyNow();
  }}
 disabled={!["active", "live"].includes(listing.listing_status)}
  style={{
    width: "100%",
    marginTop: 10,
    padding: "14px",
    color: "#fff",
    fontSize: "1rem",
fontWeight: "bold",
  border: "none",
  borderRadius: "6px",
    backgroundColor:
  
  ["active", "live"].includes(listing.listing_status)
    ? "#2e7d32"
    : "#9e9e9e",

cursor:
  ["active", "live"].includes(listing.listing_status)
    ? "pointer"
    : "not-allowed",
  }}
>
{["active", "live"].includes(listing.listing_status)
  ? "Buy Pool Care Client"
  : "Purchase in Progress"}
</button>



        <div style={{ marginTop: "30px" }}>
          <Link to="/poolcare/listings" style={backBtn}>
            ← Back to Pool Care Listings
          </Link>
        </div>
      </div>
    </div>
  );
}

/* ----------------- styles ----------------- */

const container = {
  maxWidth: "900px",
  margin: "40px auto",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
  overflow: "hidden",
};

const hero = {
  width: "100%",
  height: "260px",
  objectFit: "cover",
};

const sectionTitle = {
  borderBottom: "2px solid #a020f0",
  paddingBottom: "6px",
  marginBottom: "10px",
};

const backBtn = {
  padding: "10px 16px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  borderRadius: "6px",
  textDecoration: "none",
};

const tasksGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: "4px 24px",
};

const taskRow = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "0.95rem",
};

export default PoolCareDetails;
